import React, { useState } from 'react';
import dayjs from 'dayjs';
import { useMediaQuery } from 'react-responsive';

import TopBar from '../../hooks/TopBar';
import Calendar from './calendars/App';
import Schedules from './calendars/Schedules';
import MyEvents from './events/components/List';

const cardStyle = {
  border: '1px solid #fff',
  background: '#fff',
  padding: '16px',
  borderRadius: '12px',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
};

const OrgDashboard = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [events, setEvents] = useState([]);

  return (
    <>
      <TopBar />



      <div
        className="container-fluid py-3"
        style={{
          height: !isMobile ? 'calc(100vh - 60px)' : 'auto', // full height on desktop, auto on mobile
          overflowY: isMobile ? 'auto' : 'hidden',
          backgroundColor: '#ff9b54',
        }}
      >
        <div
          className={`d-flex flex-column ${!isMobile ? 'flex-md-row' : ''} gap-3`}
          style={{ height: !isMobile ? '100%' : 'auto' }} // full height on desktop
        >
          {isMobile && (
            <div className="w-100">
              <div style={{ ...cardStyle }}>
                <MyEvents />
              </div>
            </div>
          )}

          {/* Calendar Section */}
          <div
            className={`${isMobile ? 'w-100' : 'flex-shrink-0'} `}
            style={{ height: !isMobile ? '100%' : 'auto' }}
          >
            <CalendarSection selectedDate={selectedDate} setSelectedDate={setSelectedDate} isDesktop={!isMobile} />
          </div>

          {/* Right Section: Appointments & My Events */}
          <div
            className={`${isMobile ? 'w-100' : 'flex-grow-1'} d-flex flex-column gap-3`}
            style={{ height: !isMobile ? '100%' : 'auto' }}
          >
            <div
              className={`d-flex ${isMobile ? 'flex-column' : 'flex-row'} gap-3`}
              style={{ height: !isMobile ? '100%' : 'auto' }}
            >
              {/* Appointments */}
              <div className={`${isMobile ? 'w-100' : 'flex-grow-1'}`} style={{ height: !isMobile ? '100%' : 'auto' }}>
                <EventsSection events={events} setEvents={setEvents} selectedDate={selectedDate} isDesktop={!isMobile} />
              </div>

              {/* My Events for desktop */}
              {!isMobile && (
                <div className="flex-grow-1" style={{ height: '100%' }}>
                  <div style={{ ...cardStyle, height: '100%' }}>
                    <MyEvents />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>



    </>
  );
};

export default OrgDashboard;
function CalendarSection({ selectedDate, setSelectedDate, isDesktop }) {
  return (
    <div
      style={{
        ...cardStyle,
        padding: '20px',
        height: isDesktop ? '100%' : 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <h3 style={{ fontSize: '18px', marginBottom: '15px' }}>CALENDAR</h3>
      <div
        style={{
          flex: 1,
          minHeight: '500px', // increase calendar height here
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
      >
        <Calendar onDateClick={setSelectedDate} />
      </div>
    </div>
  );
}


function EventsSection({ events, setEvents, selectedDate, isDesktop }) {
  return (
    <div
      style={{
        ...cardStyle,
        flex: 1,
        height: isDesktop ? '100%' : 'auto',
      }}
    >
      <div
        style={{
          flex: 1,
          background: '#fff',
          padding: '16px',
          borderRadius: '12px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
          overflowY: 'auto',
        }}
      >
        <h6 style={{ fontSize: '0.85rem' }}>
          Appointments for {dayjs(selectedDate).format('MMMM D, YYYY')}
        </h6>
        <Schedules selectedDate={selectedDate} />
      </div>
    </div>
  );
}
